import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { Typography } from "@mui/material";
import FormComponent from "../../../components/gernerateForm/FormComponent";
import generateFormLeaveType from "./form/dataFormGenerate.data";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import { leaveTypeApi } from "../../../api/leave-type/leave-type.api";
import { EmployeeApi } from "../../../api/employee/employee.api";
import { useTranslation } from "react-i18next";

type Props = {};

const ManageLeaveTypeUpdate: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [inputValueFormStudent, setInputValueFormStudent] = useState<any>({
    information: {
      leave_type_name: "",
      auditor_empmloyee_id: null,
      auditor_empmloyee_position: "",
      approve_empmloyee_id: null,
      approve_empmloyee_position: "",
      leave_type_form_template: "",
      leave_days_across_years: 0,
      category: "",
    },
  });
  const [isCanEdit, setIsCanEdit] = useState(false);
  const [isValidateForm, setIsValidateForm] = useState(false);

  const validateForm = (formData: any, formConfig: any) => {
    const errors: any = {};

    formConfig.forEach((field: any) => {
      if (field.isRequired && formData[field.section][field.name] === "") {
        errors[field.name] = `${field.label} is required`;
      }
    });

    return errors;
  };

  // const handleSubmit = (leave_type_id: number, dataBody: any) => {
  //   if (leave_type_id) {
  //     const errors = validateForm(inputValueFormStudent, generateFormLeaveType);

  //     if (Object.keys(errors).length > 0) {
  //       setIsValidateForm(true);
  //     } else {
  //       setIsValidateForm(false);
  //       alertSuccess(
  //         "แก้ไขรูปแบบการลา",
  //         "แก้ไขรูปแบบการลา เรียบร้อยแล้ว",
  //         undefined,
  //         () => {}
  //       );
  //     }
  //   }
  // };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const getSingleLeaveType = async (id: number) => {
    const res = await leaveTypeApi.getLeaveTypeById(id);
    const data = res.data;
    if (data.status < 300) {
      setInputValueFormStudent({
        information: {
          leave_type_name: data.data?.leave_type_name,
          auditor_empmloyee_id: {
            value: data.data?.id_employee_inspector,
            label: "",
          },
          auditor_empmloyee_position: "",
          approve_empmloyee_id: {
            value: data.data?.id_employee_approve,
            label: "",
          },
          approve_empmloyee_position: "",
          leave_type_form_template: data.data?.id_leave_form,
          leave_days_across_years: data.data?.is_accumulate === "ได้" ? 1 : 0, // i18n-ignore
          category: data.data?.category ?? "",
        },
      });
    } else {
      setInputValueFormStudent({
        information: {
          leave_type_name: "",
          auditor_empmloyee_id: "",
          auditor_empmloyee_position: "",
          approve_empmloyee_id: "",
          approve_empmloyee_position: "",
          leave_type_form_template: "",
          leave_days_across_years: 0,
          category: "",
        },
      });
    }
  };

  useEffect(() => {
    if (id) {
      getSingleLeaveType(+id);
    }
  }, [id]);

  const handleSubmit = async (id: number, dataBody: any) => {
    const body = {
      id_leave_form: dataBody.leave_type_form_template,
      leave_type_name: dataBody.leave_type_name,
      is_accumulate: dataBody.leave_days_across_years,
      id_employee_inspector: dataBody.auditor_empmloyee_id?.value || null,
      id_employee_approve: dataBody.approve_empmloyee_id?.value || null,
      // ส่ง category เฉพาะเมื่อเลือกไว้ (รูปแบบฟอร์มอื่นจะเป็น "" -> null)
      category: dataBody.category || null,
    };

    const errors = validateForm(inputValueFormStudent, generateFormLeaveType);

    if (Object.keys(errors).length > 0) {
      setIsValidateForm(true);
    } else {
      await leaveTypeApi
        .updateLeaveType(id, body)
        .then((res) => {
          if (res.status < 300) {
            dispatch(unsetLoading());
            alertSuccess(
              t("แก้ไขรูปแบบการลา"),
              t("แก้ไขรูปแบบการลา เรียบร้อยแล้ว"),
              undefined,
              () => {
                dispatch(unsetLoading());
                setIsCanEdit(false);
              }
            );
          }
        })
        .catch(() => {
          alertError(t("แก้ไขรูปแบบการลา ไม่สำเร็จ"));
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    }
  };

  const handleDeleteLeaveType = async (id: number) => {
    if (id) {
      alertActive(
        t("ลบรูปแบบการลา"),
        t("ท่านต้องการลบรูปแบบการลา ใช่หรือไม่"),
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await leaveTypeApi
            .deleteLeaveType(+id)
            .then((res) => {
              if (res.status < 300) {
                alertSuccess(
                  t("ลบรูปแบบการลา เรียบร้อย"),
                  undefined,
                  undefined,
                  () => {
                    navigate(routeName.cms.ManageLeaveType);
                    setIsCanEdit(false);
                  }
                );
              }
            })
            .catch(() => {
              alertError(t("รูปแบบการลา ไม่สำเร็จ"));
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  const getPositionEmployee = async (
    id: number,
    field: "approve_empmloyee_position" | "auditor_empmloyee_position"
  ) => {
    try {
      const res = await EmployeeApi.getOne(id);
      const data = res.data;

      setInputValueFormStudent((prev: any) => ({
        information: {
          ...prev.information,
          [field]:
            data.status < 300
              ? data.data.work_history?.position_name ?? ""
              : "",
        },
      }));
    } catch (error) {
      setInputValueFormStudent((prev: any) => ({
        information: {
          ...prev.information,
          [field]: "",
        },
      }));
    }
  };

  useEffect(() => {
    const auditorId =
      inputValueFormStudent.information.auditor_empmloyee_id?.value;
    if (auditorId) {
      getPositionEmployee(auditorId, "auditor_empmloyee_position");
    }
  }, [inputValueFormStudent.information.auditor_empmloyee_id?.value]);

  useEffect(() => {
    const approveId =
      inputValueFormStudent.information.approve_empmloyee_id?.value;
    if (approveId) {
      getPositionEmployee(approveId, "approve_empmloyee_position");
    }
  }, [inputValueFormStudent.information.approve_empmloyee_id?.value]);

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: t("จัดการรูปแบบการลา"),
            key: "1",
            pathName: routeName.cms.ManageLeaveType,
          },
          {
            name: t("แก้ไขรูปแบบการลา"),
            key: "2",
            pathName: routeName.cms.ManageLeaveTypeCreate,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">{t("แก้ไขรูปแบบการลา")}</Typography>
      </section>

      <section className="w-full mt-10">
        <FormComponent
          formGenerate={generateFormLeaveType}
          inputValue={inputValueFormStudent}
          setInputValue={setInputValueFormStudent}
          handleCheckValid={isValidateForm}
          isCanEdit={isCanEdit}
          permission={"admin"}
        />
      </section>

      <section className="col-span-12 flex items-center justify-center gap-4 my-4">
        <ButtonOutlined
          onClick={() => {
            navigate(routeName.cms.ManageLeaveType);
          }}
          buttonName={t("ย้อนกลับ")}
          btnProps={{
            width: "150px",
          }}
        />

        {isCanEdit && (
          <ButtonPrimary
            onClick={() => {
              if (id) {
                handleSubmit(+id, inputValueFormStudent.information);
              }
            }}
            buttonName={t("บันทึก")}
            btnProps={{
              width: "150px",
            }}
            mode="next"
          />
        )}

        {!isCanEdit && (
          <ButtonPrimary
            onClick={() => {
              setIsCanEdit(true);
            }}
            buttonName={t("แก้ไข")}
            btnProps={{
              width: "150px",
            }}
          />
        )}

        {!isCanEdit && (
          <ButtonPrimary
            mode="del"
            onClick={() => {
              if (id) {
                handleDeleteLeaveType(+id);
              }
            }}
            buttonName={t("ลบ")}
            btnProps={{
              width: "150px",
            }}
          />
        )}
      </section>
    </div>
  );
};

export default ManageLeaveTypeUpdate;
